module.exports = __webpack_public_path__ + "static/media/jackpots-lvl1.fffe91f5.png";